const EfbGreyLogo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="227"
      height="275"
      viewBox="0 0 227 275"
      fill="none"
      className={className}
    >
      <path
        opacity="0.16"
        d="M215.361 28.953V82.1563C215.361 121.551 183.103 141.43 143.476 144.017V90.8139C143.476 51.3709 175.661 31.5648 215.361 28.9772M226 150.159V275.259C226 300.37 216.368 324.542 199.055 342.876C181.743 361.211 158.045 372.337 132.764 374V248.876C132.747 223.762 142.374 199.584 159.691 181.249C177.007 162.915 200.715 151.799 226 150.159ZM1.14502 1.19047C1.14502 1.19047 1.14502 6.92191 1.14502 9.77554C1.12062 65.7357 0.461795 211.392 2.16986 267.304C2.65788 283.289 8.51412 300.29 16.2492 314.727C36.624 352.719 81.6438 376.588 118.343 371.582C118.343 308.706 121.686 155.843 117.318 93.1354C113.658 40.6093 54.4612 -2.21938 1.14502 1.19047Z"
        stroke="#0A5849"
      />
    </svg>
  );
};

export default EfbGreyLogo;
